var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#26A96C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.141v7.762c0 1.041-.62 1.875-1.531 2.07-.1.021-.205.025-.307.025-3.438.002-6.876.003-10.314 0-1.03 0-1.846-.914-1.846-2.065-.003-5.56-.003-2.306 0-7.866C5 6.915 5.817 6.002 6.848 6.001 10.286 6 13.724 6 17.162 6.002c1.021 0 1.835.912 1.836 2.054.003 2.787.001.953.001.085zm-6.996.766h-3.91a1.1 1.1 0 0 0-.325.039c-.27.082-.444.398-.39.706.062.347.287.524.68.524h7.876c.097 0 .193-.01.288-.037.396-.115.542-.663.271-1.005-.151-.192-.348-.228-.56-.228h-3.93v.001zm-.009 3.867h3.893c.116 0 .23-.004.343-.038.27-.083.445-.399.39-.707-.062-.347-.287-.524-.679-.524-2.626 0-5.25 0-7.877-.002a.986.986 0 0 0-.305.043c-.375.118-.517.653-.267.985.153.201.353.243.573.243h3.93zm-.01 2.599h3.912c.116 0 .23-.006.342-.042.26-.082.434-.397.384-.693-.056-.338-.28-.533-.634-.534-2.656-.002-5.312-.002-7.968 0a.905.905 0 0 0-.251.038c-.386.114-.53.657-.27.993.15.193.344.237.557.237h3.93-.001z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchRequest);
export default ForwardRef;